import "./AboutUs.css"
import Navbar from "../components/Navbar";
import insta from '../assets/insta.jpg'
import facebook from '../assets/facebook.jpg'
import tiktok from '../assets/tiktok.png'


export default function AboutUs() {
  return (
    <div className="about-container">
        <Navbar/>
      <div className="about-content">
        <h1 className="welcome-title">Welcome to the cult, rebellious one.</h1>

        <div className="cult-figures">
          <img
            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/about_us.jpg-VaPX9lSAjJkcdXvzdPSDxk7Blnh7NQ.jpeg"
            alt="Four gothic figures with halos representing our cult aesthetic"
            className="cult-image"
          />
        </div>

        <div className="about-text">
          <p className="main-description">
            In our little haven, we specialize in <span className="highlight-red">gothic, emo, grunge, alt</span>{" "}
            fashion pieces or any other wild combo you might have in mind, selling them at an{" "}
            <span className="highlight-red">affordable</span> and <span className="highlight-red">reasonable</span>{" "}
            price.
          </p>

          <p className="disclaimer">
            Do take note that all our items are either <span className="highlight-red">preloved</span> or{" "}
            <span className="highlight-red">thrifted/ukay</span>. You might notice some signs of usage and minimal
            flaws, which are all normal given the circumstances. Just, we would appreciate if you were able to{" "}
            <span className="highlight-red">manage your expectations</span>.
          </p>
        </div>

        <div className="desert-landscape">
          <div className="red-desert"></div>
          <div className="lone-figure"></div>
        </div>

        <div className="delivery-section">
          <div className="delivery-image">
            <img
              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-Ys4YnznCWlj5qqbecTrxhdJ7W4XBJ7.png"
              alt="Gothic delivery details with nationwide and international options"
              className="delivery-bg"
            />
          </div>
          <div className="delivery-content">
            <h2 className="delivery-title">mode of delivery</h2>

            <div className="delivery-options">
              <div className="delivery-category">
                <h3 className="category-title">nationwide</h3>
                <ul className="delivery-list">
                  <li>J&T Express</li>
                  <li>LBC Padala</li>
                </ul>
              </div>

              <div className="delivery-category">
                <h3 className="category-title">international</h3>
                <ul className="delivery-list">
                  <li>J&T Express</li>
                  <li>DHL Express</li>
                  <li>PHLPost</li>
                </ul>
              </div>

              <div className="delivery-category">
                <h3 className="category-title">same day delivery</h3>
                <ul className="delivery-list">
                  <li>Lalamove</li>
                  <li>Borzo</li>
                  <li>Grab</li>
                </ul>
              </div>
            </div>

            <p className="delivery-note">
              proceed to the next slide for the estimated rates for international deliveries.
            </p>
          </div>
        </div>

        <div className="social-section">
          <h2 className="social-title">follow us into the darkness</h2>
          <div className="social-links">
            <a href="https://www.instagram.com/maackias_cult/" className="social-link instagram">
              <img src={insta} alt="Instagram" className="social-icon" />
              <span className="social-name">Instagram</span>
            </a>
            <a href="#" className="social-link tiktok">
              <img src={tiktok} alt="TikTok" className="social-icon" />
              <span className="social-name">TikTok</span>
            </a>
            <a href="#" className="social-link facebook">
              <img src={facebook} alt="Facebook" className="social-icon" />
              <span className="social-name">Facebook</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
